import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class UserSettingsRepository<
    UserSettingsModel
> extends RepositoryBase<UserSettingsModel> {
    public constructor() {
        super('userSettings');
    }
}
